import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { PICKUP_STATUS } from "pages/Picking/usePicking";

const PickupItem = ({
  item,
  halfDay,
  isReordering,
  updatePosition,
  isLastItem,
}) => {
  // Calculate pickup status based on orders
  const getPickupStatus = () => {
    if (!item.orders || item.orders.length === 0) {
      return null;
    }

    const ordersWithStatus = item.orders.filter(
      (order) => order.picking_status
    );

    if (ordersWithStatus.length === 0) {
      return null;
    }

    const allCompleted = ordersWithStatus.every(
      (order) => order.picking_status === PICKUP_STATUS.PICKUP_OK.value
    );
    const allFailed = ordersWithStatus.every(
      (order) => order.picking_status === PICKUP_STATUS.PICKUP_FAILED.value
    );
    const hasPartial = ordersWithStatus.some(
      (order) => order.picking_status === PICKUP_STATUS.PICKUP_PARTIALLY.value
    );

    if (allCompleted) return "completed";
    if (allFailed) return "failed";
    if (hasPartial || ordersWithStatus.length < item.orders.length)
      return "partial";

    return "in-progress";
  };

  const pickupStatus = getPickupStatus();
  const isCompleted = pickupStatus === "completed";
  const isPartial = pickupStatus === "partial";
  const isFailed = pickupStatus === "failed";
  return (
    <Link
      to={`/picking/${item.id}`}
      onClick={(e) => {
        if (isReordering) {
          e.preventDefault();
        }
      }}
    >
      <div
        className={`pickup-item ${isCompleted ? "-completed" : ""} ${
          isPartial ? "-partial" : ""
        } ${isFailed ? "-failed" : ""}`}
      >
        {/* Indicateur visuel pour magasin à charger */}
        <div className="pickup-item__store-indicator">
          <i
            className="fa fa-store"
            aria-hidden="true"
            title="Magasin à charger"
          />
          <span className="pickup-item__store-badge">CHARGEMENT</span>
        </div>

        {isCompleted && (
          <i
            className="fa fa-check-circle fa-lg validationIcon"
            aria-hidden="true"
          />
        )}

        <div className="pickup-item__top-container">
          <div className="pickup-item__store">
            <span className="pickup-item__label">Magasin</span>
            <span className="pickup-item__value">{item.code}</span>
          </div>
          <div className="pickup-item__reference">
            <span className="pickup-item__label">Référence</span>
            <span className="pickup-item__value">CHARGEMENT {item.name}</span>
          </div>
        </div>
        <div className="pickup-item__bottom-container">
          <i className="fa fa-dolly" aria-hidden="true" title="Chargement" />
          {item.orders && item.orders.length > 0 && (
            <span className="pickup-item__order-count">
              {item.orders.length} commande{item.orders.length > 1 ? "s" : ""}
            </span>
          )}
        </div>
        <i
          className={`fa fa-chevron-right ${isReordering ? "hidden" : ""}`}
          aria-hidden="true"
        />
        {isReordering && (
          <div>
            {Number(item.position) !== 1 && (
              <button
                type="button"
                className="reorder -up button button-outline"
                onClick={updatePosition({
                  halfDay,
                  item,
                  direction: "UP",
                })}
              >
                <i className="fa fa-arrow-up" aria-hidden="true" />
              </button>
            )}
            {!isLastItem && (
              <button
                type="button"
                className="reorder -down button button-outline"
                onClick={updatePosition({
                  halfDay,
                  item,
                  direction: "DOWN",
                })}
              >
                <i className="fa fa-arrow-down" aria-hidden="true" />
              </button>
            )}
          </div>
        )}
      </div>
    </Link>
  );
};

PickupItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    round_line_position: PropTypes.number.isRequired,
    orders: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        picking_status: PropTypes.string,
      })
    ),
  }),
  halfDay: PropTypes.string.isRequired,
  updatePosition: PropTypes.func.isRequired,
  isReordering: PropTypes.bool.isRequired,
  isLastItem: PropTypes.bool.isRequired,
};

export default PickupItem;
